import {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {Input, List, Modal} from "antd";
import {useTranslation} from "react-i18next";
import "./DialogTemplate.css"
import {marginRight} from "html2canvas/dist/types/css/property-descriptors/margin";
import {SearchOutlined} from "@ant-design/icons";
import {imgPathPerfix, isStringNullOrEmpty} from "@/utils";
import {ipcSend} from "@/common/ipc";
import {IconClose} from "@/Icon";

let mArrayCurrentTemplate:any = [];
const DialogTemplate = forwardRef((props:{onTemplateItemClick:any},ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }));
    const {t} = useTranslation();


    const DEFAULT_ARRAY_LEFT_MENU = [
        // {
        //     id:'all',
        //     title: t('All'),
        //     isSelect:true,
        //     children:[
        //         {
        //             id:'1',
        //             title:'模板名称1',
        //             cover:'imgs/template/1.jpeg'
        //         },
        //         {
        //             id:'2',
        //             title:'模板名称2',
        //             cover:'imgs/template/2.jpeg'
        //         },
        //         {
        //             id:'3',
        //             title:'模板名称3',
        //             cover:'imgs/template/3.jpeg'
        //         },
        //         {
        //             id:'4',
        //             title:'模板名称4',
        //             cover:'imgs/template/4.jpeg'
        //         }
        //     ]
        // },
        // {
        //     id:'categories',
        //     title: t('Categories'),
        //     isSelect:false,
        //     children:[
        //         {
        //             id:'1',
        //             title:'模板名称1',
        //             cover:'imgs/template/1.jpeg'
        //         }
        //     ]
        // },
        {
            id:'articles',
            title: t('Articles'),
            isSelect:false,
            children:[
                {
                    id:'1',
                    title:'模板名称1',
                    cover:'imgs/template/1.jpeg'
                },
                {
                    id:'2',
                    title:'模板名称2',
                    cover:'imgs/template/2.jpeg'
                }
            ]
        },
        {
            id:'bios',
            title: t('Bio'),
            isSelect:false,
            children:[
                {
                    id:'1',
                    title:'模板名称1',
                    cover:'imgs/template/1.jpeg'
                },
                {
                    id:'2',
                    title:'模板名称2',
                    cover:'imgs/template/2.jpeg'
                },
                {
                    id:'3',
                    title:'模板名称3',
                    cover:'imgs/template/3.jpeg'
                }
            ]
        },
    ];

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [arrayLeftMenu,setArrayLeftMenu] = useState(DEFAULT_ARRAY_LEFT_MENU);
    const [arrayTemplate,setArrayTemplate] = useState([]);
    const [searchKey,setSearchKey] = useState('');
    const [isAllSelected,setIsAllSelected] = useState(true);

    useEffect(()=>{

    },[])

    const onShowDialog = ()=>{
        setIsShowDialog(true);
        setSearchKey('');
        mArrayCurrentTemplate = arrayLeftMenu[0].children;
        setArrayTemplate(mArrayCurrentTemplate);

        // var arrayNewLeftMenu = [...DEFAULT_ARRAY_LEFT_MENU];
        // arrayNewLeftMenu.forEach(p=>p.isSelect = false);
        // arrayNewLeftMenu[0].isSelect = true;
        // setArrayLeftMenu(arrayNewLeftMenu);
        onAllClick();
    }

    /**
     * 左侧菜单点击
     * @param e
     */
    const onMenuItemClick = (e)=>{
        var nIndex = e.currentTarget.dataset.index;

        var arrayNewLeftMenu = [...DEFAULT_ARRAY_LEFT_MENU];
        var template = arrayNewLeftMenu[nIndex];
        if ('categories' === template.id)return;

        arrayNewLeftMenu.forEach(p=>p.isSelect = false);
        template.isSelect = true;
        setArrayLeftMenu(arrayNewLeftMenu);

        var arrayNewTemplate = [];
        mArrayCurrentTemplate = template.children;
        mArrayCurrentTemplate.forEach(p=>{
            if(p.title.indexOf(searchKey) != -1){
                arrayNewTemplate.push(p);
            }
        })
        setArrayTemplate(arrayNewTemplate);
        setIsAllSelected(false);
    }

    /**
     * 搜索
     * @param e
     */
    const onInputChanged = (e)=>{
        var szKey = e.currentTarget.value;
        setSearchKey(szKey);
        //search...
        var arrayNewTemplate = [];
        mArrayCurrentTemplate.forEach(p=>{
            if(p.title.indexOf(szKey) != -1){
                arrayNewTemplate.push(p);
            }
        })
        setArrayTemplate(arrayNewTemplate);
    }

    /**
     * 模板点击
     * @param e
     */
    const onTemplateItemClick = (e)=>{
        var nId = e.currentTarget.dataset.id;
        props.onTemplateItemClick(nId);
        setIsShowDialog(false);
    }

    /*全部*/
    const onAllClick = ()=>{
        var arrayNewLeftMenu = [...DEFAULT_ARRAY_LEFT_MENU];

        var arrayAllTemplate = [];
        arrayNewLeftMenu.forEach(p=>{
            p.isSelect = false;
            arrayAllTemplate.push(...p.children);
        })
        setArrayLeftMenu(arrayNewLeftMenu);
        setIsAllSelected(true);
        //all
        mArrayCurrentTemplate = arrayAllTemplate;

        var arrayNewTemplate = [];
        if (isStringNullOrEmpty(searchKey)){
            arrayNewTemplate.push(...arrayAllTemplate);
        }else{
            mArrayCurrentTemplate.forEach(p=>{
                if(p.title.indexOf(searchKey) != -1){
                    arrayNewTemplate.push(p);
                }
            })
        }

        setArrayTemplate(arrayNewTemplate);
    }

    /*渲染菜单*/
    const renderMenuItem = (item)=> {
        if (item.id == 'categories') {
            return (
                <span style={{color: '#888888', marginLeft: '0px'}}>{item.title}</span>
            )
        } else {
            return (
                <span style={{
                    width:'calc(100% + 16px)',height:'32px',
                    display:'flex',
                    alignItems:'center',
                    backgroundColor: item.isSelect ? 'var(--hover-background-color)' : 'transparent',
                    marginLeft: '-16px',
                    paddingLeft:'16px'
                }}>{item.title}</span>
            )
        }
    }

    return(
        <Modal visible={isShowDialog} footer={''}
               centered={true}
               width={'1076px'}
               bodyStyle={{height:'730px'}}
               closeIcon={<IconClose/>}
               onCancel={()=>setIsShowDialog(false)}>
            <div className='div-template-container font-size-12'>
                <Input prefix={<img className='img-mini-small' src={imgPathPerfix()+"search.png"}/>} style={{width:'260px'}} placeholder={t("Search template")} value={searchKey} onChange={onInputChanged}/>
                <div className='div-template-container-body'>
                    <div className='template-left-part' style={{marginLeft:'-20px'}}>
                        <div onClick={onAllClick} className='hovered flex-row-vertical-center' style={{height:'32px',fontSize:'14px',width:'100%'}}>
                            <span className='flex-row-vertical-center' style={{paddingLeft:'16px',width:'100%',height:'100%',backgroundColor:isAllSelected?'var(--hover-background-color)':'transparent'}}>{t("All")}</span>
                        </div>
                        <div style={{height:'32px'}}></div>

                        <div className='flex-row-vertical-center text-color-a' style={{height:'32px',fontSize:'14px'}}>
                            <span  style={{paddingLeft:'16px'}}>{t("Categories")}</span>
                        </div>

                        <List
                            bordered={false}
                            split={false}
                            itemLayout="horizontal"
                            dataSource={arrayLeftMenu}
                            renderItem={(item, index) => (
                                <List.Item data-index={index} onClick={onMenuItemClick}>
                                    {renderMenuItem(item)}
                                </List.Item>
                            )}/>
                    </div>

                    <div className='template-right-part'>
                        <List
                            grid={{
                                gutter: 16,
                                column:3
                            }}
                            bordered={false}
                            split={false}
                            itemLayout="horizontal"
                            dataSource={arrayTemplate}
                            renderItem={(item, index) => (
                                <List.Item data-id={item.id} onClick={onTemplateItemClick}>
                                    <div className='template-item cursor-pointer'>
                                        <div style={{display:'flex',flexDirection:'column',
                                            alignItems:'center',justifyContent:'center',
                                            width:'100%',height:'100%',
                                            position:'relative',borderRadius:'8px',overflow:'hidden'}}>
                                            <img style={{height:'154px',objectFit:'fill'}} src={item.cover}/>
                                            <div className='template-item-alpha'>
                                                <span className='button-solid-style'>{t("Add Template")}</span>
                                            </div>
                                        </div>
                                        <span style={{marginTop:'6px'}}>{item.title}</span>
                                    </div>

                                </List.Item>
                            )}/>
                    </div>
                </div>

                <div className='line' style={{height:'calc(100% - 56px)',width:'1px',left:'144px',top:'56px', position:'absolute'}}/>
                <div onClick={()=>ipcSend("open-url",import.meta.env.VITE_HTTP_TEMPLATE_URL)} className='flex-row-vertical-center hovered cursor-pointer'
                     style={{flexShrink:'0',position:'absolute',bottom:'18px',marginLeft:'-22px',height:'32px',paddingLeft:'16px', width:'140px'}}>
                    <span>{t("More templates")}</span>
                    <img style={{width:'10px',height:'10px'}} className='ml-6' src={imgPathPerfix()+"more_template.png"}/>
                </div>
            </div>
        </Modal>
    )
});

export default DialogTemplate;